import { Pagination, PaginationProps } from "react-admin";

const CustomPagination = (props: PaginationProps) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

export default CustomPagination;
